module.exports = __webpack_public_path__ + "img/chanceofsnow.7848228e.png";